import { useContext } from 'react'
import { Storage } from '../config/storage'
import { InitialContext } from '../context/InitialContext'

export default function useStorage(): Storage {
    const { storage } = useContext(InitialContext)
    return storage
}
